import Vue from 'vue'
import CompositionApi from '@vue/composition-api'

import App from './App.vue'
import { router } from './router'
import { store } from './store'
import VueRouter from 'vue-router'

import '@telia/core-atoms'
import TeliaCoreIcon from '@telia/core-icons'

import 'core-js/es/array'
import './assets/scss/main.scss'

//fixes object.value vuelidate method for IE11
import 'babel-polyfill'

// fixes missing styles in production build
import '@telia/grid/build/telia-grid.css'
import '@telia/tc-colors'

import 'flatpickr'

import AnslClosable from '@/directives/ansl-closable.ts'

import CookiePolicyLink from '@/components/cookie-consent/link-components/CookiePolicyLink.vue'

Vue.use(AnslClosable)

Vue.config.productionTip = false
Vue.use(CompositionApi)
Vue.use(VueRouter)
Vue.component('TeliaCoreIcon', TeliaCoreIcon)
Vue.component('cookie-policy-link', CookiePolicyLink)

import { defineCustomElements } from '@teliads/components/loader'
defineCustomElements(window)

import { registerIconsBundle } from '@teliads/icons'
registerIconsBundle()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#ansl-root')
